export const FYDEOS_NOTES_PRODUCT = 'FydeOS Notes';
export const FYDEOS_AI_PROVIDER_NAME = 'FydeOS AI';

export const FYDEOS_NOTES_FEATURES = {
  desktopAppBridge: false,
  localWorkspaceSharing: false,
  guestLocalWorkspace: true,
  upstreamCommerce: false,
  webLocalWorkspaceCloudConversion: false,
} as const;

export function canOfferDesktopAppBridge(isWeb: boolean) {
  return isWeb && FYDEOS_NOTES_FEATURES.desktopAppBridge;
}

export function canShowWorkspaceShareMenu(workspaceFlavour: string) {
  return (
    workspaceFlavour !== 'local' || FYDEOS_NOTES_FEATURES.localWorkspaceSharing
  );
}

export function canUseGuestLocalWorkspace(
  isWeb: boolean,
  serverAllowsGuestWorkspace: boolean
) {
  return (
    serverAllowsGuestWorkspace &&
    (!isWeb || FYDEOS_NOTES_FEATURES.guestLocalWorkspace)
  );
}

export function canShowUpstreamCommerce() {
  return FYDEOS_NOTES_FEATURES.upstreamCommerce;
}

export function canOfferWebLocalWorkspaceCloudConversion(
  isWeb: boolean,
  workspaceFlavour: string
) {
  return (
    !isWeb ||
    workspaceFlavour !== 'local' ||
    FYDEOS_NOTES_FEATURES.webLocalWorkspaceCloudConversion
  );
}
